export default __webpack_public_path__ + "static/media/0157.e4bf79c0.png";